import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'components';

import { H5 } from 'components/typography';
import { Charge } from 'lane-shared/domains/billingPayments/types';
import { type SupportedPaymentCurrency } from 'domains-billing-currency';
import { Chip, ChipStyle } from 'components/ads';

import styles from './ChargeItemsTable.scss';

import { SupportedLocaleEnum } from 'localization';
import { ItemRow } from '../ItemRow/ItemRow';
import { getChargeStatus } from 'lane-shared/helpers/features';

const mapColorToChipStyle = (color: string): ChipStyle => {
  switch (color) {
    case 'blue':
      return ChipStyle.Blue;
    case 'grey':
      return ChipStyle.Grey;
    case 'yellow':
      return ChipStyle.Yellow;
    case 'red':
      return ChipStyle.Red;
    case 'green':
      return ChipStyle.Green;
    default:
      return ChipStyle.Yellow;
  }
};

export function ChargeItemsTable({
  charge,
  currency,
  locale,
  showStatus,
}: {
  charge: Charge;
  currency: SupportedPaymentCurrency;
  locale: SupportedLocaleEnum;
  showStatus?: boolean;
}) {
  const { t } = useTranslation();
  const { name, items, status } = charge;
  const chargeStatus = getChargeStatus(status, charge);

  const shouldShowStatus = showStatus ?? true;

  return (
    <Flex className={styles.ChargeItemsTable} direction="column" gap={5}>
      <Flex justify="space-between" align="center">
        <H5>
          {t('abp.charges.chargeManager.list.chargeItem', {
            name,
          })}
        </H5>
        {shouldShowStatus && (
          <Chip
            value={chargeStatus[0]}
            type={mapColorToChipStyle(chargeStatus[1])}
            size="xs"
            testId="status-chip"
          />
        )}
      </Flex>
      {items.map((item, index) => (
        <ItemRow
          key={item.id || index}
          item={item}
          currency={currency}
          locale={locale}
        />
      ))}
    </Flex>
  );
}
